import { StringType } from "./strings";

const STRING_DE: StringType = {
  translation: {
    general: {
      loading: "Laden...",
    },
    burgerMenu: {
      dutyPlan: "Ämtliplan",
      dashboard: "Dashboard",
      lights: "Lichter",
      jokeOfTheDay: "Witz des Tages",
      settings: "Einstellungen",
      deliveryDriver: "Essensfahrer",
      wifi: "WLAN",
      camera: "Kamera",
      images: "Bilder",
      scavengerhunt: "Schnitzeljagd",
    },
    dutyCard: {
      tasks: "Aufgaben",
      tasksInDetail: "Aufgaben im Detail",
      everyWeek: "Jede Woche",
      everyXWeeks_one: "Alle {{count}} Woche",
      everyXWeeks_other: "Alle {{count}} Wochen",
      day_one: "{{count}} Tag",
      day_other: "{{count}} Tage",
    },
    trashCalendar: {
      title: "Abfallkalender",
    },
    duties: {
      bathroom: {
        name: "Bad",
        quote:
          "Wer jemandem in die Schüssel scheisst, muss mit den Konsequenzen rechnen!",
        generalTasks: {
          bathroom: "Bad",
          trash: "Kehricht",
        },
        detailedTasks: {
          cleanToilet: "WC putzen",
          cleanSink: "Lavabo putzen",
          cleanShower: "Dusche putzen",
          cleanFurniture: "Gestelle putzen",
          disposeTrash: "Kehricht entsorgen",
          disposeCompost: "Kompost entsorgen",
        },
      },
      floor: {
        name: "Böden",
        quote: "Der Boden hält uns für immer und ewig!",
        generalTasks: {
          livingRoom: "Wohnzimmer",
          floor: "Boden",
          glasAndCans: "Glas & Dosen",
        },
        detailedTasks: {
          cleanSofa: "Sofa reinigen",
          lamps: "Lampen",
          vacuumClean: "Staubsaugen",
          wipeFloor: "Feucht aufnehmen",
          disposeGlasAndCans: "Glas & Dosen entsorgen",
          waterPlants: "Pflanzen giessen",
        },
      },
      kitchen: {
        name: "Küche",
        quote: "Ohne ein El Tony kann selbst der aller beste nichts erreichen!",
        generalTasks: {
          kitchen: "Küche",
          petAndPlasticBottles: "PET- und Plastikflaschen",
          cardboardAndPaper: "Karton und Papier",
        },
        detailedTasks: {
          cleanStoveTableAndSink: "Herd, Tisch und Lavabo putzen",
          cleanSurfaces: "Oberflächen putzen",
          cleanTrashCabinet: "Abfallschrank putzen",
          cleanSteamExhaust: "Dampfabzug putzen",
          disposeCardboardAndPaper: "Karton und Papier entsorgen",
          disposePetAndPlasticBottles: "PET- und Plastikflaschen entsorgen",
        },
      },
    },
    weatherCodes: {
      sunny: "Sonnig",
      clear: "Klar",
      mainlySunny: "Größtenteils Sonnig",
      mainlyClear: "Größtenteils Klar",
      partlyCloudy: "Teilweise Bewölkt",
      cloudy: "Bewölkt",
      foggy: "Nebelig",
      rimeFog: "Nebel",
      lightDrizzle: "Leichter Nieselregen",
      drizzle: "Nieselregen",
      heavyDrizzle: "Starker Nieselregen",
      lightFreezingDrizzle: "Leichter Eiskalter Nieselregen",
      freezingDrizzle: "Eiskalter Nieselregen",
      lightRain: "Leichter Regen",
      rain: "Regen",
      heavyRain: "Starker Regen",
      lightFreezingRain: "Leichter Eiskalter Regen",
      freezingRain: "Eiskalter Regen",
      lightSnow: "Leichter Schnee",
      snow: "Schnee",
      heavySnow: "Starker Schnee",
      snowGrains: "Schneekörner",
      lightShowers: "Leichtes Schauerwetter",
      showers: "Schauerwetter",
      heavyShowers: "Starkes Schauerwetter",
      lightSnowShowers: "Leichtes Schneeschauerwetter",
      snowShowers: "Schneeschauerwetter",
      thunderstorm: "Gewitter",
      lightThunderstormsWithHail: "Leichtes Gewitter mit Hagel",
      thunderstormWithHail: "Gewitter mit Hagel",
    },
    deliveryDrivers: {
      orderedOn: "Bestellt am",
      order: "Bestellung:",
    },
    camera: {
      done: "Fertig!",
      imagePreviewInfoText: "Das Bild kann man auf der Bilderseite sehen",
    },
    settings: {
      language: "Sprache",
      theme: "Thema",
      reload: "Website neu laden",
    },
  },
};

export default STRING_DE;
